<div id="dvLoadingScreen" class="text-center full-width-div">
  <h3>Loading...</h3>
</div>
